import React from 'react';
import {Box, Stack} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import Skeleton from '@/components/skeleton';
import {
  RootCard,
  CardContainer,
  CardSpacer,
  HeaderContainer,
  AssetContainer,
  ProgressContainer,
  ProgressInfo,
  FooterContainer,
  FeatureIconContainer,
  Boxes,
  StackedBox,
} from './ProjectCard.styles';

interface ProjectCardSkeletonProps {
  testID?: string;
}

function ProjectCardSkeleton({
  testID = 'project-card-skeleton',
}: ProjectCardSkeletonProps) {
  return (
    <RootCard data-testid={testID}>
      <CardContainer>
        <HeaderContainer>
          <AssetContainer>
            <Stack paddingX="16px" width="100%" height="100%">
              <Boxes>
                <StackedBox rotation="-7.5deg" />
                <StackedBox rotation="7deg" />
                <StackedBox rotation="0deg" opacity={1} />
              </Boxes>
            </Stack>
          </AssetContainer>

          <Skeleton
            variant="circular"
            width={24}
            height={24}
            backgroundColor={designSystemToken('semantic.fg.disabled')}
          />
        </HeaderContainer>
        <CardSpacer />
        <ProgressContainer>
          <ProgressInfo>
            <Box sx={{display: 'flex', gap: '4px'}}>
              <Skeleton
                variant="rectangular"
                width={35}
                height={24}
                borderRadius="6px"
                backgroundColor={designSystemToken('semantic.fg.disabled')}
              />
              <Skeleton
                variant="rectangular"
                width={24}
                height={24}
                borderRadius="6px"
                backgroundColor={designSystemToken('semantic.fg.disabled')}
              />
            </Box>
            <Skeleton
              variant="text"
              width={30}
              height={20}
              backgroundColor={designSystemToken('semantic.fg.disabled')}
            />
          </ProgressInfo>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={4}
            backgroundColor={designSystemToken('semantic.fg.disabled')}
          />
        </ProgressContainer>
      </CardContainer>
      <FooterContainer>
        <FeatureIconContainer
          background={designSystemToken('semantic.fg.disabled')}
        >
          <Skeleton
            variant="circular"
            width={17.33}
            height={17.33}
            backgroundColor={designSystemToken('semantic.fg.disabled')}
          />
        </FeatureIconContainer>
        <Box flex={1}>
          <Skeleton
            variant="text"
            width={120}
            height={16}
            backgroundColor={designSystemToken('semantic.fg.disabled')}
          />
        </Box>
        <Skeleton
          variant="text"
          width={80}
          height={14}
          backgroundColor={designSystemToken('semantic.fg.disabled')}
        />
      </FooterContainer>
    </RootCard>
  );
}

export default ProjectCardSkeleton;
